<template>
  <div class="bb-progress-bottom-wrapper d-flex justify-content-center">
    <div v-for="s in customstates.states" v-if="!s.hidden">
      <span class="nav-bottom-title" v-html="s.textName"></span>
      <span v-if="s.name==='bandbuilder.silicone.graphics'"><br><small>(Optional)</small></span>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    props: [],
    computed: {
      ...mapState([
        // map this.customband to store.state.customband
        'customband',
        'customstates'
      ])
    }
  }
</script>
